import logo from './logo.ico';
import Projects from './Projects';
import './App.css';

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <img src={logo} className="App-logo" alt="logo" />
        <h1 className="App-title">This is SuloCorp</h1>
        <p className="App-slogan">Re-imagine Society</p>
        <p className="App-tagline"><small>Own a piece!</small></p>
        <p className="App-description"> &nbsp; </p>
        <a
          className="App-link"
          href="https://www.facebook.com/profile.php?id=100090181080833&mibextid=ZbWKwL"
          target="_blank"
          rel="noopener noreferrer"
        >
          Our Facebook Page
        </a>
        <Projects />
      </header>
    </div>
  );
}

export default App;

